<template>
  <div class="page">
    <div class="bg-content padding15">
      <div class="m-b-24">
        <el-button type="primary" size="small" @click="addFsInfoShow" plain>添加服务</el-button>
        <el-button type="primary" size="small" @click="addSupplierInfoShow" plain>添加线路商</el-button>
        <el-button type="primary" size="small" @click="addSbcShow" plain>添加SBC</el-button>
      </div>
      <div class="padding15-tb">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="FS服务" name="fs">
            <el-form size="small" label-width="50px" ref="searchRef">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="Fs服务名称" label-width="100px">
                      <el-input v-model="searchReq.supplierName" placeholder="请输入服务名称" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="备注" label-width="100px">
                      <el-input v-model="searchReq.confDesc" placeholder="请输入服务备注" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="0">
                    <div class="text right">
                      <el-button type="primary" size="small" plain @click="searchReq.page = 1; listFsInfo();"><i class="fa fa-search"></i> 搜索</el-button>
                      <el-button size="small" @click="searchReq.supplierName = null;searchReq.confDesc = null">重置</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            <el-table size="small" :data="fsInfos.list" stripe highlight-current-row>
              <el-table-column property="fsName" fixed label="Fs服务名称"/>
              <el-table-column property="fsOutHost" label="对外地址" min-width="120"/>
              <el-table-column property="fsPort" label="端口号"/>
              <el-table-column property="fsTimeout" label="超时时间(ms)"/>
              <el-table-column property="fsConcurrency" label="并发数" min-width="60"/>
              <el-table-column property="fsExternalInfo" label="扩展信息" min-width="180"/>
              <el-table-column property="boundBoxNames" label="所在资源组" min-width="120"/>
              <el-table-column property="fsDesc" label="备注" min-width="120"/>
              <el-table-column label="服务类型" min-width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.fsType === 0">指定型</div>
                  <div v-if="scope.row.fsType === 1" style="color: #909399;">公共型</div>
                </template>
              </el-table-column>
              <el-table-column label="是否有效" min-width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.fsType === 0" style="color: #67C23A;">--</div>
                  <div v-if="scope.row.fsType === 1 && !scope.row.fsIsValid" style="color: #F56C6C;">无效</div>
                  <div v-if="scope.row.fsType === 1 && scope.row.fsIsValid" style="color: #67C23A;">有效</div>
                </template>
              </el-table-column>
              <el-table-column label="权重" min-width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.fsType === 0">--</div>
                  <div v-if="scope.row.fsType === 1">{{scope.row.fsWeight}}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="editFsInfoShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>编 辑</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="text center margin15-tb">
              <el-pagination background layout="prev, pager, next, sizes, total"
                  :total="fsInfos.totalRecords" :page-sizes="[10, 50, 100, 200]"
                  :page-size="searchReq.limit" :current-page="searchReq.page"
                  @current-change="currentChangeConf" @size-change="sizeChangeConf"/>
            </div>
          </el-tab-pane>
          <el-tab-pane label="线路商" name="sc">
            <el-form size="small" label-width="50px" ref="searchRef">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="线路商名称" label-width="100px">
                      <el-input v-model="searchSuppComReq.companyName" placeholder="请输入线路商名称" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="备注" label-width="100px">
                      <el-input v-model="searchSuppComReq.remark" placeholder="请输入线路商备注" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="0">
                    <div class="text right">
                      <el-button type="primary" size="small" plain @click="searchSuppComReq.page = 1; listSupplierInfo();"><i class="fa fa-search"></i> 搜索</el-button>
                      <el-button size="small" @click="searchSuppComReq.companyName = null;searchSuppComReq.remark = null">重置</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            <el-table size="small" :data="supplierInfos.list" stripe highlight-current-row>
              <el-table-column property="companyName" fixed label="线路商名称"/>
              <el-table-column property="boundBoxNames" label="所在资源组"/>
              <el-table-column property="remark" label="备注"/>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="editSupplierInfoShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>编 辑</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="text center margin15-tb">
              <el-pagination background layout="prev, pager, next, sizes, total"
                  :total="supplierInfos.totalRecords" :page-sizes="[10, 50, 100, 200]"
                  :page-size="searchSuppComReq.limit" :current-page="searchSuppComReq.page"
                  @current-change="currentChangeSupplier" @size-change="sizeChangeSupplier"/>
            </div>
          </el-tab-pane>

          <el-tab-pane label="SBC" name="sbc">
            <el-form size="small" label-width="50px" ref="searchRef">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="SBC名称" label-width="100px">
                      <el-input v-model="searchSbcReq.sbcName" placeholder="请输入SBC组名称" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="ip" label-width="100px">
                      <el-input v-model="searchSbcReq.ip" placeholder="请输入IP" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="0">
                    <div class="text right">
                      <el-button type="primary" size="small" plain @click="searchSbcReq.page = 1; listSbcInfo();"><i class="fa fa-search"></i> 搜索</el-button>
                      <el-button size="small" @click="searchSbcReq.sbcName = null;searchSbcReq.ip = null;listSbcInfo();">重置</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            <el-table size="small" :data="sbcInfos.list" stripe highlight-current-row>
              <el-table-column property="id" fixed label="ID"/>
              <el-table-column property="sbcName" fixed label="SBC名称"/>
              <el-table-column property="sbcGw" label="SBC对应网关"/>
              <el-table-column property="kamailioIp" label="Kamailio IP"/>
              <el-table-column property="kamailioPort" label="Kamailio Port"/>
              <el-table-column property="rtpEngineList" label="RTPengine list"/>
              <el-table-column label="是否有效" min-width="60">
                <template slot-scope="scope">
                  <div v-if="scope.row.isValid === false" style="color: #F56C6C;">无效</div>
                  <div v-if="scope.row.isValid === true" style="color: #67C23A;">有效</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="editSbcInfoShow(scope.row)" size="small"><i class="el-icon-edit-outline"></i>编 辑</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="text center margin15-tb">
              <el-pagination background layout="prev, pager, next, sizes, total"
                  :total="sbcInfos.totalRecords" :page-sizes="[10, 50, 100, 200]"
                  :page-size="searchSbcReq.limit" :current-page="searchSbcReq.page"
                  @current-change="currentChangeSbc" @size-change="sizeChangeSbc"/>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="dialog">
        <!--添加修改服务-->
        <el-dialog :title="isAdd?'添加FS服务':'修改FS服务'" :visible.sync="serverVisable" width="70%" center>
          <el-form size="small" label-width="130px" class="margin15-tb">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="FS服务名称：">
                  <el-input v-model="fsInfo.fsName"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="对内地址：">
                  <el-input v-model="fsInfo.fsInHost"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="对外地址：">
                  <el-input v-model="fsInfo.fsOutHost"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="端口号：">
                  <el-input v-model="fsInfo.fsPort"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="密码：">
                  <el-input type="password" v-model="fsInfo.fsPassword"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="FS服务类型：">
                  <el-select v-model="fsInfo.fsType" :value="fsInfo.fsType" @change="changeType" placeholder="请选择服务类型" style="width: 100%;">
                    <el-option :value="0" label="指定型服务器"/>
                    <el-option :value="1" label="公共型服务器"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="超时时间（毫秒）：">
                  <el-input-number :min="0" v-model="fsInfo.fsTimeout" style="width: 100%;"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="并发数：">
                  <el-input-number :min="0" v-model="fsInfo.fsConcurrency" style="width: 100%;"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="拓展信息：">
                  <el-input v-model="fsInfo.fsExternalInfo"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注：">
                  <el-input v-model="fsInfo.fsDesc"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-if="isCommomType">
              <el-col :span="12">
                <el-form-item label="是否有效：">
                  <el-switch
                    v-model="fsInfo.fsIsValid"
                    active-color="#f6ac19"
                    inactive-color="#282828">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="权重：">
                  <el-input-number :min="0" :max="100" v-model="fsInfo.fsWeight" style="width: 100%;"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveFsInfo" v-if="isAdd">提 交</el-button>
            <el-button type="primary" @click="updateFsInfo" v-if="!isAdd">修 改</el-button>
          </span>
        </el-dialog>
        <!--添加/修改sbc-->
        <el-dialog :title="isAddSbc?'添加SBC':'修改SBC'" :visible.sync="sbcVisable" width="35%" center>
          <el-form size="small" label-width="130px" class="margin15-tb">
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="SBC名称">
                  <el-input v-model="sbcInfo.sbcName"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="SBC对应网关">
                  <el-input v-model="sbcInfo.sbcGw"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="Kamailio Ip">
                  <el-input v-model="sbcInfo.kamailioIp"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="Kamailio Port">
                  <el-input v-model="sbcInfo.kamailioPort"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="Rtpengine List">
                  <el-input v-model="sbcInfo.rtpEngineList"/>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="是否有效">
                     <el-switch
                      v-model="sbcInfo.isValid"
                      active-color="#f6ac19"
                      inactive-color="#282828">
                    </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveSbcInfo" v-if="isAddSbc">提 交</el-button>
            <el-button type="primary" @click="updateSbcInfo" v-if="!isAddSbc">修 改</el-button>
          </span>
        </el-dialog>
        <!--添加修改线路商-->
        <el-dialog :title="isAddSupplier?'添加线路商':'修改线路商'" :visible.sync="supplierVisable" width="35%" center>
          <el-form size="small" label-width="130px" class="margin15-tb">
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="线路商名称：">
                  <el-input v-model="supplierInfo.companyName"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="备注：">
                  <el-input v-model="supplierInfo.remark"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveSupplierInfo" v-if="isAddSupplier">提 交</el-button>
            <el-button type="primary" @click="updateSupplierInfo" v-if="!isAddSupplier">修 改</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fsInfos: {
        label: 'FS服务',
        value: 'fs',
        totalRecords: null,
        list: []
      },
      supplierInfos: {
        label: '线路商',
        value: 'sc',
        totalRecords: null,
        list: []
      },
      sbcInfos: {
        label: 'SBC',
        value: 'sbc',
        totalRecords: null,
        list: []
      },
      supplierVisable: false,
      sbcVisable: false,
      serverVisable: false,
      isAdd: true,
      isCommomType: false,
      fsInfo: {
        id: null,
        fsName: null,
        fsInHost: null,
        fsOutHost: null,
        fsPort: null,
        fsPassword: null,
        fsTimeout: null,
        fsConcurrency: null,
        fsExternalInfo: null,
        fsDesc: null,
        fsType: null,
        fsIsValid: null,
        fsWeight: null
      },
      sbcInfo: {
        id: null,
        sbcName: null,
        sbcGw: null,
        kamailioIp: null,
        kamailioPort: null,
        isValid: null,
        rtpEngineList: null
      },
      supplierInfo: {
        id: null,
        companyName: null,
        remark: null
      },
      isAddSupplier: false,
      isAddSbc: false,
      activeName: 'fs',
      searchReq: {
        type: null,
        supplierName: null,
        confDesc: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      searchSbcReq: {
        type: null,
        sbcName: null,
        ip: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      searchSuppComReq: {
        type: null,
        companyName: null,
        remark: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      }
    };
  },
  methods: {
    handleClick() {
      if (this.activeName === 'fs') {
        this.listFsInfo();
      } else if (this.activeName === 'sc') {
        this.listSupplierInfo();
      } else if (this.activeName === 'sbc') {
        this.listSbcInfo();
      }
    },
    currentChangeConf(page) {
      this.searchReq.page = page;
      this.listFsInfo();
    },
    // 显示条数
    sizeChangeConf(num) {
      this.searchReq.limit = num;
      this.listFsInfo();
    },
    // fs列表
    listFsInfo() {
      this.$ajax({
        method: 'POST',
        url: '/callServer/listFsInfo',
        data: this.searchReq
      }).then((res) => {
        this.fsInfos.list = res.data.list;
        this.fsInfos.totalRecords = res.data.totalRecords;
      });
    },
    // 添加服务显示
    addFsInfoShow() {
      // 配置信息
      this.fsInfo.id = null;
      this.fsInfo.fsName = null;
      this.fsInfo.fsInHost = null;
      this.fsInfo.fsOutHost = null;
      this.fsInfo.fsPort = 0;
      this.fsInfo.fsPassword = null;
      this.fsInfo.fsTimeout = 0;
      this.fsInfo.fsConcurrency = 0;
      this.fsInfo.fsExternalInfo = null;
      this.fsInfo.fsDesc = null;
      this.fsInfo.fsType = 0;
      this.fsInfo.fsIsValid = false;
      this.fsInfo.fsWeight = 0;
      // 显示控制
      this.serverVisable = true;
      this.isAdd = true;
      this.isCommomType = false;
    },
    // 保存服务
    saveFsInfo() {
      this.$ajax({
        prompt: true,
        method: 'POST',
        data: this.fsInfo,
        url: '/callServer/saveFsInfo'
      }).then(() => {
        this.serverVisable = false;
        this.listFsInfo();
      });
    },
    // 编辑服务显示
    editFsInfoShow(row) {
      this.serverVisable = true;
      this.isAdd = false;
      if (row.fsType === 0) {
        this.isCommomType = false;
      } else if (row.fsType === 1) {
        this.isCommomType = true;
      }
      this.buildRowReq(row);
    },
    // 修改服务
    updateFsInfo() {
      this.$confirm('您确认要修改该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'POST',
          data: this.fsInfo,
          url: `/callServer/updateFsInfo/${this.fsInfo.id}`
        }).then(() => {
          this.serverVisable = false;
          this.listFsInfo();
        });
      });
    },
    buildRowReq(row) {
      this.fsInfo.id = row.id;
      this.fsInfo.fsName = row.fsName;

      if (row.fsInHost === undefined || row.fsInHost === null || row.fsInHost === '') {
        this.fsInfo.fsInHost = '********';
      } else {
        this.fsInfo.fsInHost = row.fsInHost;
      }
      this.fsInfo.fsOutHost = row.fsOutHost;
      this.fsInfo.fsPort = row.fsPort;
      if (row.fsPassword === undefined || row.fsPassword === null || row.fsPassword === '') {
        this.fsInfo.fsPassword = '******';
      } else {
        this.fsInfo.fsPassword = row.fsPassword;
      }
      this.fsInfo.fsTimeout = row.fsTimeout;
      this.fsInfo.fsConcurrency = row.fsConcurrency;
      this.fsInfo.fsExternalInfo = row.fsExternalInfo;
      this.fsInfo.fsDesc = row.fsDesc;
      this.fsInfo.fsType = row.fsType;
      this.fsInfo.fsIsValid = row.fsIsValid;
      this.fsInfo.fsWeight = row.fsWeight;
    },
    changeType() {
      if (this.fsInfo.fsType === 0) {
        this.isCommomType = false;
      } else if (this.fsInfo.fsType === 1) {
        this.isCommomType = true;
      }
    },
    // sbc
    currentChangeSbc(page) {
      this.searchSbcReq.page = page;
      this.listSbcInfo();
    },
    // sbc显示条数
    sizeChangeSbc(num) {
      console.warn(num);
      this.searchSbcReq.limit = num;
      this.listSbcInfo();
    },
    // 线路商
    currentChangeSupplier(page) {
      this.searchSuppComReq.page = page;
      this.listSupplierInfo();
    },
    // 显示条数
    sizeChangeSupplier(num) {
      console.warn(num);
      this.searchSuppComReq.limit = num;
      this.listSupplierInfo();
    },
    // 线路商列表
    listSupplierInfo() {
      this.$ajax({
        method: 'POST',
        url: '/callServer/listSupplierInfo',
        data: this.searchSuppComReq
      }).then((res) => {
        this.supplierInfos.list = res.data.list;
        this.supplierInfos.totalRecords = res.data.totalRecords;
      });
    },
    // sbc列表
    listSbcInfo() {
      this.$ajax({
        method: 'POST',
        url: '/callServer/listSbcInfo',
        data: this.searchSbcReq
      }).then((res) => {
        this.sbcInfos.list = res.data.list;
        this.sbcInfos.totalRecords = res.data.totalRecords;
      });
    },
    // 添加服务显示
    addSupplierInfoShow() {
      // 配置信息
      this.supplierInfo.id = null;
      this.supplierInfo.companyName = null;
      this.supplierInfo.remark = null;
      // 显示控制
      this.supplierVisable = true;
      this.isAddSupplier = true;
    },
    // 添加SBC界面显示
    addSbcShow() {
      this.sbcInfo.id = null;
      this.sbcInfo.sbcGw = null;
      this.sbcInfo.kamailioIp = null;
      this.sbcInfo.kamailioPort = null;
      this.sbcInfo.rtpEngineList = null;
      this.sbcInfo.isValid = true;
      // 控制显示信息
      this.sbcVisable = true;
      this.isAddSbc = true;
    },
    // 保存sbc接口调用
    saveSbcInfo() {
      this.$ajax({
        prompt: true,
        method: 'POST',
        data: this.sbcInfo,
        url: '/callServer/saveSbcInfo'
      }).then(() => {
        this.sbcVisable = false;
        this.listSbcInfo();
      });
    },
    // 保存服务
    saveSupplierInfo() {
      this.$ajax({
        prompt: true,
        method: 'POST',
        data: this.supplierInfo,
        url: '/callServer/saveSupplierInfo'
      }).then(() => {
        this.supplierVisable = false;
        this.listSupplierInfo();
      });
    },
    // 编辑sbc
    editSbcInfoShow(row) {
      this.sbcVisable = true;
      this.isAddSbc = false;
      this.buildRowReqSbc(row);
    },
    // 编辑服务显示
    editSupplierInfoShow(row) {
      this.supplierVisable = true;
      this.isAddSupplier = false;
      this.buildRowReqSupplier(row);
    },
    // 修改sbc
    updateSbcInfo() {
      this.$confirm('您确认要修改该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'POST',
          data: this.sbcInfo,
          url: `/callServer/updateSbcInfo/${this.sbcInfo.id}`
        }).then(() => {
          this.sbcVisable = false;
          this.listSbcInfo();
        });
      });
    },
    // 修改服务
    updateSupplierInfo() {
      this.$confirm('您确认要修改该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'POST',
          data: this.supplierInfo,
          url: `/callServer/updateSupplierInfo/${this.supplierInfo.id}`
        }).then(() => {
          this.supplierVisable = false;
          this.listSupplierInfo();
        });
      });
    },
    buildRowReqSbc(row) {
      this.sbcInfo.id = row.id;
      this.sbcInfo.sbcName = row.sbcName;
      this.sbcInfo.sbcGw = row.sbcGw;
      this.sbcInfo.kamailioIp = row.kamailioIp;
      this.sbcInfo.kamailioPort = row.kamailioPort;
      this.sbcInfo.rtpEngineList = row.rtpEngineList;
      this.sbcInfo.isValid = row.isValid;
    },
    buildRowReqSupplier(row) {
      this.supplierInfo.id = row.id;
      this.supplierInfo.companyName = row.companyName;
      this.supplierInfo.remark = row.remark;
    }
  },
  mounted() {
    // fs列表
    this.listFsInfo();
    // 线路商
    this.listSupplierInfo();
  }
};
</script>
<style>
  div.el-transfer .el-transfer-panel {width: 40%;}
</style>



// WEBPACK FOOTER //
// src/page/main/call/service/index.vue